import axios from './axios';
import { RsvpResponse, RsvpSummary, CardEvent } from '../../utils/invitation';

export type MyRsvp = { response: RsvpResponse; guests: number; note: string; updatedAt: string };

// `token` is the recipient link's `t`; every path segment and the token are URI-encoded
const recipientUrl = (cardId: string, recipientId: string, token: string) =>
	`/rsvp/${encodeURIComponent(cardId)}/${encodeURIComponent(recipientId)}?t=${encodeURIComponent(token)}`;

const getMine = (
	cardId: string,
	recipientId: string,
	token: string,
): Promise<{ event: CardEvent | null; rsvp: MyRsvp | null }> =>
	axios({ method: 'get', url: recipientUrl(cardId, recipientId, token) }).then((resp) => resp.data.data);

const submit = (
	cardId: string,
	recipientId: string,
	token: string,
	body: { response: RsvpResponse; guests?: number; note?: string },
): Promise<MyRsvp> =>
	axios({ method: 'put', url: recipientUrl(cardId, recipientId, token), data: body }).then((resp) => resp.data.data);

const getSummary = (cardId: string): Promise<RsvpSummary> =>
	axios({ method: 'get', url: `/rsvp/card/${encodeURIComponent(cardId)}` }).then((resp) => resp.data.data);

export const rsvp_services = { getMine, submit, getSummary };
